"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var ReferralItem_1 = require("./parts/ReferralItem");
var validations_1 = require("lib/functions/validations");
var findErrors_1 = require("lib/functions/findErrors");
var referrals = [
    {
        id: "referral1",
        name: "First Referral"
    },
    {
        id: "referral2",
        name: "Second Referral"
    },
    {
        id: "referral3",
        name: "Third Referral"
    }
];
var rules = {};
referrals.forEach(function (referral) {
    var rulesForReferral = {};
    rulesForReferral[referral.id + "_name"] = validations_1.mandatory;
    rulesForReferral[referral.id + "_relationship"] = validations_1.mandatory;
    rulesForReferral[referral.id + "_telephone"] = validations_1.mandatory;
    rules = Object.assign(rules, rulesForReferral);
});
var ReferralList = (function (_super) {
    __extends(ReferralList, _super);
    function ReferralList(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    ReferralList.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    ReferralList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                console.log("+++++++++++++++");
                console.log(this.constructor.name);
                console.log("+++++++++++++++");
                this.props.model.addValidateFunction("validateReferralList", this.isValid);
                return [2];
            });
        });
    };
    ReferralList.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateReferralList");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    ReferralList.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    ReferralList.prototype.isValid = function () {
        console.log("Validate Referrals");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        if (this.errors) {
            console.log("referrals errors", this.errors);
        }
        return isValid;
    };
    ReferralList.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "REFERRALS"),
            referrals.map(function (ed) { return (React.createElement(ReferralItem_1.ReferralItem, { key: ed.id, id: ed.id, name: ed.name, json_data: json_data, onChange: onChange, errors: errors })); })));
    };
    __decorate([
        mobx_1.observable
    ], ReferralList.prototype, "errors", void 0);
    ReferralList = __decorate([
        mobx_react_1.observer
    ], ReferralList);
    return ReferralList;
}(react_1.Component));
exports.ReferralList = ReferralList;
//# sourceMappingURL=data:application/json;base64,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